// extracted by css-extract-rspack-plugin
export default {"monalisa-wrapper":"NNvmjl","monalisaWrapper":"NNvmjl","monalisa-icon":"MaktDW","monalisaIcon":"MaktDW"};